var _a;
var ComponentsOptions;
(function (ComponentsOptions) {
  ComponentsOptions["OptionsForm"] = "OptionsForm";
  ComponentsOptions["RecentLoginMethods"] = "RecentLoginMethods";
  ComponentsOptions["EmailForm"] = "EmailForm";
  ComponentsOptions["CreatePasswordForm"] = "CreatePasswordForm";
  ComponentsOptions["InsertPasswordForm"] = "InsertPasswordForm";
  ComponentsOptions["AccountTermination"] = "AccountTermination";
  ComponentsOptions["ToGetStarted"] = "ToGetStarted";
  ComponentsOptions["NoInternet"] = "NoInternet";
  ComponentsOptions["WelcomeBackEmailCodeAndSSO"] = "WelcomeBackEmailCodeAndSSO";
  ComponentsOptions["WelcomeBackMultipleSSO"] = "WelcomeBackMultipleSSO";
  ComponentsOptions["UsernameForm"] = "UsernameForm";
  ComponentsOptions["UsernameFormSSO"] = "UsernameFormSSO";
})(ComponentsOptions || (ComponentsOptions = {}));
var AuthFlow;
(function (AuthFlow) {
  AuthFlow["Default"] = "default";
  AuthFlow["RecentLoginMethods"] = "suggested_login";
})(AuthFlow || (AuthFlow = {}));
var AnalyticsScreenNameOptions;
(function (AnalyticsScreenNameOptions) {
  AnalyticsScreenNameOptions["OptionsForm"] = "general";
  AnalyticsScreenNameOptions["RecentLoginMethods"] = "suggested_login";
  AnalyticsScreenNameOptions["EmailForm"] = "email_flow";
  AnalyticsScreenNameOptions["CreatePasswordForm"] = "new";
  AnalyticsScreenNameOptions["InsertPasswordForm"] = "returning";
  AnalyticsScreenNameOptions["NoInternet"] = "connection_lost";
  AnalyticsScreenNameOptions["ToGetStarted"] = "consent_screen";
  AnalyticsScreenNameOptions["WelcomeBackMultipleSSO"] = "welcome_back";
  AnalyticsScreenNameOptions["WelcomeBackEmailCodeAndSSO"] = "welcome_back";
  AnalyticsScreenNameOptions["UsernameForm"] = "username_form";
  AnalyticsScreenNameOptions["UsernameFormSSO"] = "username_form_sso";
})(AnalyticsScreenNameOptions || (AnalyticsScreenNameOptions = {}));
var AnalyticsActionOptions;
(function (AnalyticsActionOptions) {
  AnalyticsActionOptions["SignIn"] = "sign_in";
  AnalyticsActionOptions["SignUp"] = "sign_up";
  AnalyticsActionOptions["Skip"] = "skip";
})(AnalyticsActionOptions || (AnalyticsActionOptions = {}));
var RegistrationActionOptions;
(function (RegistrationActionOptions) {
  RegistrationActionOptions["SignUp"] = "sign_up";
  RegistrationActionOptions["EmptyString"] = "";
  RegistrationActionOptions["Combined"] = "combined";
})(RegistrationActionOptions || (RegistrationActionOptions = {}));
var RECENT_LOGIN_BTN_PULSE_NAME = 'username';
var ANALYTICS_SCREEN_NAME_KEY = 'reg-analytics-screen';
var ANALYTICS_CONSENTS_KEY = 'reg-consents-screen';
var AnalyticsSkipScreenOptions;
(function (AnalyticsSkipScreenOptions) {
  AnalyticsSkipScreenOptions["General"] = "general";
  AnalyticsSkipScreenOptions["EmailFlow"] = "email_flow";
  AnalyticsSkipScreenOptions["New"] = "new";
  AnalyticsSkipScreenOptions["Returning"] = "returning";
  AnalyticsSkipScreenOptions["Connection"] = "connection";
  AnalyticsSkipScreenOptions["Termination"] = "account_termination";
  AnalyticsSkipScreenOptions["ToGetStarted"] = "consent_screen";
})(AnalyticsSkipScreenOptions || (AnalyticsSkipScreenOptions = {}));
var AnalyticsSocialItemOptions;
(function (AnalyticsSocialItemOptions) {
  AnalyticsSocialItemOptions["Google"] = "reg_select_google";
  AnalyticsSocialItemOptions["Apple"] = "reg_select_apple";
  AnalyticsSocialItemOptions["Facebook"] = "reg_select_fb";
})(AnalyticsSocialItemOptions || (AnalyticsSocialItemOptions = {}));
var AuthActionOptions;
(function (AuthActionOptions) {
  AuthActionOptions["SignIn"] = "signIn";
  AuthActionOptions["SignUp"] = "signup";
  AuthActionOptions["SignInWithCode"] = "signInWithCode";
})(AuthActionOptions || (AuthActionOptions = {}));
var AuthActionConfig = (_a = {}, _a[AuthActionOptions.SignIn] = {
  endpoint: 'user-account/auth/signin',
  analyticName: AnalyticsActionOptions.SignIn
}, _a[AuthActionOptions.SignUp] = {
  endpoint: 'user-account/auth/signup',
  analyticName: AnalyticsActionOptions.SignUp
}, _a[AuthActionOptions.SignInWithCode] = {
  endpoint: 'user-account/auth/signin/code',
  analyticName: AnalyticsActionOptions.SignIn
}, _a);
var RegexpOptions;
(function (RegexpOptions) {
  RegexpOptions["ValidEmailAddress"] = "(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\b\x0B\f\x0E-\x1F!#-[]-\x7F]|\\\\[\x01-\t\x0B\f\x0E-\x7F])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\b\x0B\f\x0E-\x1F!-ZS-\x7F]|\\\\[\x01-\t\x0B\f\x0E-\x7F])+)\\])";
  RegexpOptions["ExpectedLength"] = "^.{8,16}$";
  RegexpOptions["AtLeastOneCharacter"] = "[a-zA-Z]";
  RegexpOptions["AtLeastOneNumber"] = ".*[0-9].*";
})(RegexpOptions || (RegexpOptions = {}));
var StatusOptions;
(function (StatusOptions) {
  StatusOptions["Success"] = "Success";
  StatusOptions["Warning"] = "Warning";
  StatusOptions["Error"] = "Error";
  StatusOptions["Default"] = "Default";
  StatusOptions["Submitting"] = "Submitting";
  StatusOptions["TextFieldStatuses"] = "TextFieldStatuses";
})(StatusOptions || (StatusOptions = {}));
var RegErrorReasons;
(function (RegErrorReasons) {
  RegErrorReasons["Consents"] = "consents_not_provided";
})(RegErrorReasons || (RegErrorReasons = {}));
var RestrictedGeoZones;
(function (RestrictedGeoZones) {
  RestrictedGeoZones["Russia"] = "RU";
  RestrictedGeoZones["Japan"] = "JP";
  RestrictedGeoZones["SouthKorea"] = "KR";
})(RestrictedGeoZones || (RestrictedGeoZones = {}));
var AUTH_BUTTON_TEXT = 'Log in or sign up';
var FACEBOOK_PLATFORM_SCRIPT_URL = 'https://connect.facebook.net/en_US/sdk.js';
var GOOGLE_PLATFORM_SCRIPT_URL = 'https://accounts.google.com/gsi/client';
var APPLE_PLATFORM_SCRIPT_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
var SocialProviderOptions;
(function (SocialProviderOptions) {
  SocialProviderOptions["google"] = "google";
  SocialProviderOptions["apple"] = "apple";
  SocialProviderOptions["facebook"] = "facebook";
})(SocialProviderOptions || (SocialProviderOptions = {}));
var ProviderOptions;
(function (ProviderOptions) {
  ProviderOptions["email"] = "email";
})(ProviderOptions || (ProviderOptions = {}));
var ConsentType;
(function (ConsentType) {
  ConsentType["biometric"] = "biometrics_consent";
  ConsentType["marketing"] = "email_subscription_consent";
})(ConsentType || (ConsentType = {}));

export { ANALYTICS_SCREEN_NAME_KEY as A, ConsentType as C, FACEBOOK_PLATFORM_SCRIPT_URL as F, GOOGLE_PLATFORM_SCRIPT_URL as G, ProviderOptions as P, RestrictedGeoZones as R, StatusOptions as S, ANALYTICS_CONSENTS_KEY as a, AuthActionOptions as b, SocialProviderOptions as c, AnalyticsActionOptions as d, ComponentsOptions as e, RegErrorReasons as f, AuthActionConfig as g, AuthFlow as h, AnalyticsSocialItemOptions as i, AnalyticsSkipScreenOptions as j, APPLE_PLATFORM_SCRIPT_URL as k, RECENT_LOGIN_BTN_PULSE_NAME as l, AnalyticsScreenNameOptions as m, RegistrationActionOptions as n, AUTH_BUTTON_TEXT as o, RegexpOptions as p };
//# sourceMappingURL=constants-e3c79897.js.map
